export default __webpack_public_path__ + "static/media/batman-spiderman.571d4be1.pdf";